import { DocumentRequest } from '../../models';
const data = (requestId: string): DocumentRequest => {
    return {
        id: requestId,
        isCompleted: false,
        branding: {
            clientId: 'DAV',
            brandId: 'GRP',
        },
        heading: '',
        subHeading: '',
        documents: [
            {
                id: 'DocumentIdOne',
                instruction: 'Document One Instruction',
                uploadedDocuments: [],
            },
            {
                id: 'DocumentIdTwo',
                instruction: 'Document Two Instruction',
                uploadedDocuments: [],
            },
        ],
    };
};

export default data;
